import axios from "@/axios";

export default async function getVimeoId(asset, locale = "en-us") {
  const embibeId = asset.embibeId;
  let {data} = await axios({
    url: `https://beta-api.embibe.com/cg-fiber-ms/learning_objects/?where={%22id%22%3A%20${embibeId}%20}&lo_type=Video&locale=${locale}`,
    method: "get"
  })
  let vimeoId, srtUrl;
  try {
    vimeoId = data._items[0].content.key_attributes.url_no_anchor.split("/").reverse()[1];
    srtUrl = data._items[0].content.custom_attributes.subtitle_url_us_english_vtt
  } catch(err) {
    console.log("error getting vimeoId", err);
  }
  return {vimeoId, srtUrl};
}

// export default function getVimeoId(asset) {
//   let vimeoId = asset.vimeoId;
//   if (!vimeoId) {
//     const videoVimeoTypes = ["url_no_anchor", "url", "url_no_anchor_no_narration"];
//     const cdnUrlKey = videoVimeoTypes.filter(s => asset[s] && asset[s].includes('vimeo.com'))[0];
//     let vimeoMatch = asset[cdnUrlKey].match(/vimeo.com\/(\d+)\/?/i);
//     vimeoId = (vimeoMatch || [])[1];
//   }
//   return vimeoId;
// }
